module.exports = __webpack_public_path__ + "8ca86545f03cd0e86dda28cdbdb6bbda.svg";